import { SubmitToSandboxSettingsFormWebComponent } from './component/SubmitToSandboxSettingsFormWebComponent';
import { WEB_COMPONENT_SUBMIT_TO_SANDBOX_SETTINGS_FORM } from '../../../../webcomponents.constants';

export { SubmitToSandboxSettingsFormWebComponent };

window.customElements.define(WEB_COMPONENT_SUBMIT_TO_SANDBOX_SETTINGS_FORM, SubmitToSandboxSettingsFormWebComponent);
